import { render, staticRenderFns } from "./EmptyCampo.vue?vue&type=template&id=7242a357&scoped=true&"
import script from "./EmptyCampo.vue?vue&type=script&lang=js&"
export * from "./EmptyCampo.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCampo.vue?vue&type=style&index=0&id=7242a357&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242a357",
  null
  
)

export default component.exports